/**
 * Keeps track of the dropdown panels that are currently open so that opening one
 * closes the others. Bootstrap dropdowns and react-select menus are separate
 * widgets that know nothing about each other, so without this they can end up
 * open at the same time.
 */

interface IOpenDropdownEntry {
    /** root element of the dropdown, used to detect nested panels */
    element: HTMLElement | null
    close: () => void
}

const openDropdowns = new Map<string, IOpenDropdownEntry>()

export const registerOpenDropdown = (id: string, entry: IOpenDropdownEntry) => {
    openDropdowns.set(id, entry)
}

export const unregisterOpenDropdown = (id: string) => {
    openDropdowns.delete(id)
}

/**
 * Closes every open dropdown except the one being opened, and except the ones
 * containing it - a dropdown nested inside another panel must not close its own parent.
 */
export const closeOtherOpenDropdowns = (id: string, openedNode?: Node | null) => {
    openDropdowns.forEach((entry, entryId) => {
        if (entryId === id) return
        if (openedNode && entry.element?.contains(openedNode)) return
        entry.close()
    })
}
